import React from 'react';
import Icon from '../../../components/AppIcon';

const RiskAlertsSection = ({ risks }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'high':
        return 'text-error';
      case 'medium':
        return 'text-warning';
      case 'low':
        return 'text-success';
      default:
        return 'text-muted-foreground';
    }
  };

  const getSeverityBackground = (severity) => {
    switch (severity) {
      case 'high':
        return 'bg-error/10 border-error/20';
      case 'medium':
        return 'bg-warning/10 border-warning/20';
      case 'low':
        return 'bg-success/10 border-success/20';
      default:
        return 'bg-muted/50 border-border';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'high':
        return 'AlertTriangle';
      case 'medium':
        return 'AlertCircle';
      case 'low':
        return 'Info';
      default:
        return 'Info';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8 elevation-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-error/20 flex items-center justify-center">
          <Icon name="Shield" size={20} color="var(--color-error)" />
        </div>
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Risk Alerts & Mitigation
        </h3>
      </div>
      <div className="space-y-4">
        {risks?.map((risk) => (
          <div
            key={risk?.id}
            className={`p-4 md:p-5 rounded-lg border ${getSeverityBackground(risk?.severity)}`}
          >
            <div className="flex items-start gap-4">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${getSeverityBackground(risk?.severity)}`}>
                <Icon
                  name={getSeverityIcon(risk?.severity)}
                  size={18}
                  color={`var(--color-${risk?.severity === 'high' ? 'error' : risk?.severity === 'medium' ? 'warning' : 'success'})`}
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-2">
                  <h4 className="text-sm md:text-base font-medium text-foreground font-body">
                    {risk?.title}
                  </h4>
                  <span
                    className={`text-xs font-medium font-caption px-2 py-1 rounded w-fit capitalize ${getSeverityColor(risk?.severity)} ${getSeverityBackground(risk?.severity)}`}
                  >
                    {risk?.severity} Risk
                  </span>
                </div>
                <p className="text-sm text-muted-foreground font-body mb-3">
                  {risk?.description}
                </p>
                <div className="p-3 bg-background rounded-md">
                  <div className="flex items-start gap-2 mb-2">
                    <Icon name="CheckCircle2" size={14} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
                    <span className="text-xs font-medium text-foreground font-caption">
                      Mitigation Strategy
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground font-body pl-5">
                    {risk?.mitigation}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RiskAlertsSection;